import axios from '../../../localAxios';
import { WorkspaceRole } from '../../getWorkspaceMembers';
import { changeWorkspaceRoleURL } from '../../workspacesURLs';

interface ChangeRoleParams {
  workspaceId: string;
  userId: string;
  role: WorkspaceRole;
}
export const changeWorkspaceRole = async ({
  workspaceId,
  userId,
  role,
}: ChangeRoleParams) => {
  const result = await axios.put(
    changeWorkspaceRoleURL(workspaceId, userId).href,
    {
      role,
    }
  );
  return result;
};
